<template>
	<div id="app">
		<Header v-show="showHeader" v-bind:nav="navIndex"></Header>
		<router-view />
		<Footer v-show="showFooter"></Footer>
		<!-- <GoTop></GoTop> -->
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				navIndex: '',
				showHeader: true,
				showFooter: true,
			}
		},
		watch: {
			'$route'(to, from) {
				// 在这里执行路由变化时的逻辑
				if (to.path == '/register' || to.path == '/login' || to.path == '/forgotPassword' || to.path ==
					'/orderList') {
					this.showHeader = false
					this.showFooter = false
				} else {
					this.navIndex = sessionStorage.getItem('navIndex')
					this.showHeader = true
					this.showFooter = true
				}

				if (from.path == '/login' && to.path == '/home') {
					window.location.reload()
				}

			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue